// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* filepath: c:\\Users\\USER\\Desktop\\GitHub Repos\\github-emu-portal\\src\\components\\MainNavBar\\MainNavBar.css */
.main-sidebar-wrapper {
  position: relative;
  height: auto;
}

.main-sidebar {
  background-color: #000000;
  height: calc(100vh);
  width: 240px;
  transition: width 0.3s ease;
  color: white;
  display: flex;
  flex-direction: column;
  position: sticky;
  position: -webkit-sticky;
}

.main-sidebar.fixed-sidebar {
  position: sticky;
  position: -webkit-sticky;
  top: 0;
  z-index: 100;
}

.main-sidebar-wrapper.collapsed .main-sidebar {
  width: 70px;
}

.sidebar-header {
  display: flex;
  align-items: center;
  padding: 20px 16px;
  height: 64px;
}

.sidebar-logo {
  font-size: 28px;
  flex-shrink: 0;
}

.sidebar-title {
  margin-left: 12px;
  font-size: 18px;
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.collapse-btn {
  margin-left: auto;
  background: transparent;
  border: none;
  color: white;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px;
  border-radius: 50%;
  transition: background-color 0.2s;
}

.collapse-btn:hover {
  background-color: rgba(255, 255, 255, 0.1);
}

.sidebar-divider {
  height: 1px;
  background-color: rgba(255, 255, 255, 0.08);
  margin: 0 20px;
}

.sidebar-nav {
  display: flex;
  flex-direction: column;
  padding: 16px 0;
}

.nav-item {
  display: flex;
  align-items: center;
  padding: 10px 16px;
  text-decoration: none;
  color: rgba(255, 255, 255, 0.7);
  transition: background-color 0.15s, color 0.15s;
  margin: 5px 8px;
  border-radius: 6px;
}

.nav-item:hover {
  background-color: rgba(255, 255, 255, 0.08);
  color: white;
}

.nav-item.active {
  background-color: rgba(255, 255, 255, 0.12);
  color: white;
  font-weight: 600;
}

.nav-icon {
  font-size: 20px;
  flex-shrink: 0;
  opacity: 0.75;
}

.nav-item.active .nav-icon,
.nav-item:hover .nav-icon {
  opacity: 1;
}

.nav-text {
  margin-left: 16px;
  white-space: nowrap;
}

/* Layout adjustment for main content */
.main-content-with-sidebar {
  margin-left: 240px;
  transition: margin-left 0.3s ease;
}

.main-content-with-sidebar.sidebar-collapsed {
  margin-left: 70px;
}`, "",{"version":3,"sources":["webpack://./src/pages/homeDashboard/NavBar/sideNavbar.css"],"names":[],"mappings":"AAAA,4GAA4G;AAC5G;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;EACZ,2BAA2B;EAC3B,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,MAAM;EACN,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,uBAAuB;EACvB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,2CAA2C;EAC3C,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,qBAAqB;EACrB,+BAA+B;EAC/B,+CAA+C;EAC/C,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,2CAA2C;EAC3C,YAAY;AACd;;AAEA;EACE,2CAA2C;EAC3C,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,aAAa;AACf;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA,uCAAuC;AACvC;EACE,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,iBAAiB;AACnB","sourcesContent":["/* filepath: c:\\Users\\USER\\Desktop\\GitHub Repos\\github-emu-portal\\src\\components\\MainNavBar\\MainNavBar.css */\n.main-sidebar-wrapper {\n  position: relative;\n  height: auto;\n}\n\n.main-sidebar {\n  background-color: #000000;\n  height: calc(100vh);\n  width: 240px;\n  transition: width 0.3s ease;\n  color: white;\n  display: flex;\n  flex-direction: column;\n  position: sticky;\n  position: -webkit-sticky;\n}\n\n.main-sidebar.fixed-sidebar {\n  position: sticky;\n  position: -webkit-sticky;\n  top: 0;\n  z-index: 100;\n}\n\n.main-sidebar-wrapper.collapsed .main-sidebar {\n  width: 70px;\n}\n\n.sidebar-header {\n  display: flex;\n  align-items: center;\n  padding: 20px 16px;\n  height: 64px;\n}\n\n.sidebar-logo {\n  font-size: 28px;\n  flex-shrink: 0;\n}\n\n.sidebar-title {\n  margin-left: 12px;\n  font-size: 18px;\n  font-weight: 600;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.collapse-btn {\n  margin-left: auto;\n  background: transparent;\n  border: none;\n  color: white;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 4px;\n  border-radius: 50%;\n  transition: background-color 0.2s;\n}\n\n.collapse-btn:hover {\n  background-color: rgba(255, 255, 255, 0.1);\n}\n\n.sidebar-divider {\n  height: 1px;\n  background-color: rgba(255, 255, 255, 0.08);\n  margin: 0 20px;\n}\n\n.sidebar-nav {\n  display: flex;\n  flex-direction: column;\n  padding: 16px 0;\n}\n\n.nav-item {\n  display: flex;\n  align-items: center;\n  padding: 10px 16px;\n  text-decoration: none;\n  color: rgba(255, 255, 255, 0.7);\n  transition: background-color 0.15s, color 0.15s;\n  margin: 5px 8px;\n  border-radius: 6px;\n}\n\n.nav-item:hover {\n  background-color: rgba(255, 255, 255, 0.08);\n  color: white;\n}\n\n.nav-item.active {\n  background-color: rgba(255, 255, 255, 0.12);\n  color: white;\n  font-weight: 600;\n}\n\n.nav-icon {\n  font-size: 20px;\n  flex-shrink: 0;\n  opacity: 0.75;\n}\n\n.nav-item.active .nav-icon,\n.nav-item:hover .nav-icon {\n  opacity: 1;\n}\n\n.nav-text {\n  margin-left: 16px;\n  white-space: nowrap;\n}\n\n/* Layout adjustment for main content */\n.main-content-with-sidebar {\n  margin-left: 240px;\n  transition: margin-left 0.3s ease;\n}\n\n.main-content-with-sidebar.sidebar-collapsed {\n  margin-left: 70px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
